/**
 * Stable search query keys for dedupe, cache, and analytics (M17).
 */
import { parseVehicleSearchParams, serializeVehicleSearchParams } from "./vehicleSearchParamsUrl";

/**
 * Canonical key for a public vehicle search request.
 * @param {string} slug
 * @param {object} params
 * @param {string} [profileId]
 */
export function buildVehicleSearchQueryKey(slug, params = {}, profileId) {
  const normalized = parseVehicleSearchParams(params);
  const serialized = serializeVehicleSearchParams({
    ...normalized,
    page: normalized.page || 1,
    pageSize: normalized.pageSize,
  });
  return buildSearchQueryKeyFromSerialized(slug, serialized.toString(), profileId);
}

export function buildSearchQueryKeyFromSerialized(slug, serializedParams, profileId) {
  return `${slug || "automap"}::${profileId || ""}::${serializedParams}`;
}
